import pImg1 from '../images/testimonial/sa-tes01.jpg'
import pImg2 from '../images/testimonial/sa-tes02.jpg'
import pImg3 from '../images/testimonial/sa-tes03.jpg'
import pImg4 from '../images/testimonial/sa-tes04.jpg'
import pImg5 from '../images/project/img01.png'
import pImg6 from '../images/project/img02.png'
import pImg7 from '../images/project/img03.png'
import iconQDV from '../images/project/icon-qdv.png'
import imgQDV from '../images/project/img-qdv.png'
import iconChatBot from '../images/project/icon-chatbot.png'
import iconBatransfer from '../images/project/icon-batransfer.png'
import iconUpaychat from '../images/project/icon-upaychat.jpg'
import iconFlash from '../images/project/icon-flash.png'
import imgChatBot from '../images/project/img-chatbot.png'
import imgBaTransfer from '../images/project/img-batransfer.png'
import imgUpaychat from '../images/project/img-upaychat.png'
import imgFlash from '../images/project/img-flash.png'



import icon3 from '../images/icon/pro-icon03.png'

const Project1 = [
    {
        "Id": "1",
        "pImg": "kb-rag-chatbot-img", 
        "title": "Knowledge Based RAG Chatbot",
        "slug": "knowledge-based-rag-chatbot",
        "rnumber": "450",
        "rtext": "ROI increase over 6 months",
        "tnumber": "320",
        "ttext": "In value due to enhanced team productivity",
        "snumber": "600",
        "stext": "Saved in time by automating customer support",
        "description": "Developed a Knowledge-Based RAG Chatbot that improves customer support efficiency by providing real-time, relevant answers using advanced AI-driven knowledge retrieval techniques."
    },
    {
        "Id": "2",
        "pImg": "qdv-search-ai-img",
        "title": "QDV Search AI App",
        "slug": "qdv-search-ai-app",
        "rnumber": "500",
        "rtext": "Search accuracy improvement over 3 months",
        "tnumber": "200",
        "ttext": "In value by optimizing search functionality",
        "snumber": "400",
        "stext": "Saved in search time with AI-powered suggestions",
        "description": "Launched the QDV Search AI App, which leverages machine learning to provide highly relevant search results with real-time suggestions, boosting search accuracy and reducing time spent on irrelevant results."
    }
]

const Project = [
    {
        Id: '6',
        pImg: imgChatBot, // Replace with the actual image variable
        icon: iconChatBot, // Replace with the actual icon variable
        title: 'Knowledge-Based RAG Chatbot',
        slug: 'knowledge-based-rag-chatbot',
        rtext1: 'AI',
        rtext2: 'Chatbot',
        rtext3: 'NLP',
        description: 'A Knowledge-Based RAG Chatbot leveraging Retrieval-Augmented Generation (RAG) to provide accurate and context-aware responses.',
    },
    {
        Id: '7',
        pImg: imgQDV, // Replace with the actual image variable
        icon: iconQDV, // Replace with the actual icon variable
        title: 'QDV AI Search App',
        slug: 'qdv-ai-search-app',
        rtext1: 'AI Search',
        rtext2: 'ML',
        rtext3: 'Data Retrieval',
        description: 'QDV AI Search App enhances information retrieval with intelligent AI-powered search capabilities, improving accuracy and efficiency.',
    },
    
    {
        Id: '8',
        pImg: imgBaTransfer, // Ensure this corresponds to the correct image
        icon: iconBatransfer, // Ensure this corresponds to the correct icon
        title: 'BaTransfer Taxi Booking App',
        slug: 'batransfer-taxi-booking',
        rtext1: 'App Development',
        rtext2: 'Ride-Booking',
        rtext3: 'UI/UX Design',
        description: 'BaTransfer Taxi Booking App simplifies ride-hailing with real-time tracking, seamless payments, and an intuitive user experience.',
    },
    {
        Id: '9',
        pImg: imgUpaychat, // Ensure this corresponds to the correct image
        icon: iconUpaychat, // Ensure this corresponds to the correct icon
        title: 'UpayChat Social Payment App',
        slug: 'upaychat-social-payment',
        rtext1: 'Fintech',
        rtext2: 'Mobile App',
        rtext3: 'Payment System',
        description: 'UpayChat enables seamless social payments with peer-to-peer transactions, digital wallets, and secure financial management.',
    },
    {
        Id: '10',
        pImg: imgFlash, // Ensure this corresponds to the correct image
        icon: iconFlash, // Ensure this corresponds to the correct icon
        title: 'Flash Mobile App',
        slug: 'flash-mobile-app',
        rtext1: 'Fintech',
        rtext2: 'E-commerce',
        rtext3: 'Mobile Payments',
        description: 'Flash Mobile App revolutionizes digital payments, enabling secure transactions, airtime purchases, and seamless e-commerce experiences.',
    }
    

]

export default Project;